export const parseError = (error: string | Error): Error => {
  if (typeof error === 'string') {
    return new Error(error);
  }

  return error;
};
